import { render, staticRenderFns } from "./ClienteRuralSidebar.vue?vue&type=template&id=3a1e70ae"
import script from "./ClienteRuralSidebar.vue?vue&type=script&lang=js"
export * from "./ClienteRuralSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports